import EmailIcon from './emailIcon.svg';
import FacebookIcon from './facebookIcon.svg';
import InstagramIcon from './instagramIcon.svg';
import LinkedInIcon from './linkedInIcon.svg';
import PhoneIcon from './phoneIcon.svg';

const CONTACT_FORM = {
  EmailIcon,
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  PhoneIcon,
};

const LINKS = {
  INSTAGRAM: 'https://www.instagram.com/modern.angles',
  LINKEDIN: 'https://www.linkedin.com/company/modern-angles',
  FACEBOOK: 'https://www.facebook.com/modernanglesphotography',
  TWITTER: 'https://www.twitter.com/modernangles'
}

export { CONTACT_FORM, LINKS };
